import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Box, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Add, Delete, Create, ConfirmationNumber } from '@material-ui/icons';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import GridContainer from '@jumbo/components/GridContainer';

import DatePicker, { DateObject } from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import gregorian from 'react-date-object/calendars/gregorian';
import gregorian_en from 'react-date-object/locales/gregorian_en';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';

import CmtCard from '@coremat/CmtCard';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import { fetchError } from 'redux/actions';
import EventsRequests from 'services/events';
import RemoveSectionDialog from './RemoveSectionDialog';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  formControl: {
    width: '100%',
  },
  cardRoot: {
    paddingTop: '24px',
    marginBottom: '20px',
    [theme.breakpoints.down('xs')]: {
      '& .Cmt-header-root': {
        flexDirection: 'column',
      },
      '& .Cmt-action-default-menu': {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
    paddingInline: '25px',
  },
  formContainer: {
    width: '100%',
  },
  girdContainer: {
    width: '100%',
    margin: '0',
    padding: '0',
  },
  customInput: {
    width: '80%',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
  inputContainer: {
    paddingInline: '40px !important',
    '& p': {
      fontWeight: 'bold',
      marginBottom: '16px',
    },
  },
  buttonContainer: {
    paddingInline: '40px !important',
    justifyContent: 'flex-end',
  },
  inputTitle: {
    marginBottom: '20px',
  },
  select: {
    height: '56px',
    '& .MuiOutlinedInput-input': {
      height: '25px',
    },
  },
  previewContainer: {
    width: '100%',
    paddingLeft: '50%',
    display: 'flex',
    justifyContent: 'center',
    '& img': {
      width: '190px',
    },
  },
  removeButton: {
    cursor: 'pointer',
  },
}));

const EventSecitonFiled = ({ eventID, id }) => {
  const now = new Date();
  now.setHours(18, 0, 0, 0);

  const dateFormat = {
    date: now,
    gregorian: new DateObject({ date: now, format: 'HH:mm:ss   YYYY/MM/DD' }).convert(gregorian, gregorian_en).format(),
  };

  const [sectionTitle, setSectionTitle] = useState('');
  const [sectionDesc, setSectionDesc] = useState('');
  const [maxParticipant, setMaxParticipant] = useState('');
  const [maxParticipantPerFamily, setMaxParticipantPerFamily] = useState('');
  const [fromDate, setFromDate] = useState(dateFormat);
  const [toDate, setToDate] = useState(dateFormat);
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { singleSeciton } = useSelector(({ events }) => events);

  useEffect(() => {
    if (id) {
      dispatch(EventsRequests.getEventSectionById(id));
    }
  }, [id]);

  useEffect(() => {
    if (singleSeciton) {
      if (singleSeciton._id === id) {
        setSectionTitle(singleSeciton.name);
        setSectionDesc(singleSeciton.description);
        setFromDate({
          date: singleSeciton.startDate,
          gregorian: new DateObject({ date: singleSeciton.startDate, format: 'HH:mm:ss   YYYY/MM/DD' })
            .convert(gregorian, gregorian_en)
            .format(),
        });
        setToDate({
          date: singleSeciton.endDate,
          gregorian: new DateObject({ date: singleSeciton.endDate, format: 'HH:mm:ss   YYYY/MM/DD' })
            .convert(gregorian, gregorian_en)
            .format(),
        });
        setMaxParticipant(singleSeciton.maxParticipant);
        setMaxParticipantPerFamily(singleSeciton.maxParticipantPerFamily);
      }
    }
  }, [singleSeciton]);

  const convertFromDate = (date, format = fromDate.format) => {
    let object = { date, format };
    setFromDate({
      gregorian: new DateObject(object).convert(gregorian, gregorian_en).format(),
      ...object,
    });
  };
  const convertToDate = (date, format = toDate.format) => {
    let object = { date, format };
    setToDate({
      gregorian: new DateObject(object).convert(gregorian, gregorian_en).format(),
      ...object,
    });
  };

  const convertToStandardFormat = dateString => {
    const [time, date] = dateString.split('   ');
    const [hours, minutes, seconds] = time.split(':');
    const [year, month, day] = date.split('/');
    const standardFormat = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    const dateObject = new Date(standardFormat);
    const isoString = dateObject.toISOString();
    return isoString;
  };

  const clearState = () => {
    setSectionTitle('');
    setSectionDesc('');
    setFromDate(dateFormat);
    setToDate(dateFormat);
    setMaxParticipant('');
    setMaxParticipantPerFamily('');
  };

  const handleCreateSection = () => {
    if (sectionTitle && fromDate.date && toDate.date && maxParticipant && maxParticipantPerFamily) {
      const matchData = {
        name: sectionTitle,
        description: sectionDesc,
        startDate: convertToStandardFormat(fromDate.gregorian),
        endDate: convertToStandardFormat(toDate.gregorian),
        maxParticipant: maxParticipant,
        maxParticipantPerFamily: maxParticipantPerFamily,
        event: eventID,
      };
      dispatch(EventsRequests.addEventSection(matchData));
      clearState();
    } else {
      dispatch(fetchError('موارد لازم را به درستی وارد نمایید'));
    }
  };

  const handleUpdateEventSeciton = () => {
    if (sectionTitle && fromDate.date && toDate.date && maxParticipant && maxParticipantPerFamily) {
      const matchData = {
        name: sectionTitle,
        description: sectionDesc,
        startDate: convertToStandardFormat(fromDate.gregorian),
        endDate: convertToStandardFormat(toDate.gregorian),
        maxParticipant: maxParticipant,
        maxParticipantPerFamily: maxParticipantPerFamily,
        event: eventID,
      };
      dispatch(EventsRequests.updateEventSection(id, matchData));
    } else {
      dispatch(fetchError('موارد لازم را به درستی وارد نمایید'));
    }
  };

  const handleRemoveSeciton = () => {
    dispatch(EventsRequests.removeEventSectionById(id));
    setOpenRemoveDialog(false);
  };

  return (
    <>
      <CmtCard className={classes.cardRoot}>
        <CmtCardContent className={classes.cardContentRoot}>
          <form className={classes.formContainer} noValidate autoComplete="off">
            <GridContainer className={classes.girdContainer}>
              <Grid item xs={12}>
                <TextField
                  id="sectionEventTitle"
                  label="نام سانس رخداد"
                  variant="outlined"
                  className={classes.customInput}
                  value={sectionTitle}
                  onChange={e => setSectionTitle(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="sectionDescription"
                  multiline
                  minRows={4}
                  label="توضیحات"
                  variant="outlined"
                  className={classes.customInput}
                  value={sectionDesc}
                  onChange={e => setSectionDesc(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Box display={'flex'} alignItems="center">
                  <CalendarTodayIcon fontSize="small" />
                  <Box marginLeft={2}>
                    <Typography>تاریخ شروع</Typography>
                  </Box>
                </Box>

                <DatePicker
                  containerClassName="custom-container"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="top-right"
                  value={fromDate.date}
                  onChange={convertFromDate}
                  format="HH:mm:ss   YYYY/MM/DD"
                  plugins={[<TimePicker position="right" />]}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box display={'flex'} alignItems="center">
                  <CalendarTodayIcon fontSize="small" />
                  <Box marginLeft={2}>
                    <Typography>تاریخ پایان</Typography>
                  </Box>
                </Box>
                <DatePicker
                  containerClassName="custom-container"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  value={toDate.date}
                  onChange={convertToDate}
                  format="HH:mm:ss   YYYY/MM/DD"
                  plugins={[<TimePicker position="right" />]}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.inputTitle}>حداکثر شرکت کنندگان</Typography>
                <TextField
                  id="maxParticipant"
                  label="حداکثر شرکت کنندگان"
                  variant="outlined"
                  type="number"
                  className={classes.customInput}
                  value={maxParticipant}
                  onChange={e => setMaxParticipant(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.inputTitle}>حداکثر شرکت‌کنندگان از هر خانواده</Typography>
                <TextField
                  id="maxParticipantPerFamily"
                  label="شرکت‌کنندگان از هر خانواده"
                  variant="outlined"
                  type="number"
                  className={classes.customInput}
                  value={maxParticipantPerFamily}
                  onChange={e => setMaxParticipantPerFamily(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} container className={classes.buttonContainer}>
                {id ? (
                  <>
                    <Button
                      variant="contained"
                      color="secondary"
                      startIcon={<Delete />}
                      onClick={() => setOpenRemoveDialog(true)}
                      style={{ marginLeft: 14 }}>
                      حذف
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      size="medium"
                      startIcon={<ConfirmationNumber />}
                      onClick={() => history.push(`/sectionTickets/${id}`)}
                      style={{ marginLeft: 14 }}>
                      بلیط‌های صادر شده
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      size="medium"
                      startIcon={<Create />}
                      onClick={handleUpdateEventSeciton}>
                      ویرایش سانس
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    startIcon={<Add />}
                    onClick={handleCreateSection}>
                    ساخت سانس
                  </Button>
                )}
              </Grid>
            </GridContainer>
          </form>
        </CmtCardContent>
      </CmtCard>
      <RemoveSectionDialog
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        handleRemoveAndClose={handleRemoveSeciton}
      />
    </>
  );
};

export default EventSecitonFiled;
